// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

// Pure coordinate math for the New Business annotation editor. pdfjs renders a
// page to a canvas at `scale`, so canvas pixels = PDF-user-space-units × scale.
// PDF user space has its origin at the BOTTOM-left with y increasing upward;
// the canvas origin is TOP-left with y increasing downward — hence the y-flip.
// Kept dependency-free so the conversions are exhaustively unit-testable.

/** Canvas pixel point → PDF user-space point (origin bottom-left). */
export function canvasToPdf(
  canvasX: number,
  canvasY: number,
  scale: number,
  pageHeightPdf: number,
): { x: number; y: number } {
  const x = canvasX / scale;
  const y = pageHeightPdf - canvasY / scale;
  return { x: round(x), y: round(y) };
}

/** PDF user-space point (origin bottom-left) → canvas pixel point. */
export function pdfToCanvas(
  pdfX: number,
  pdfY: number,
  scale: number,
  pageHeightPdf: number,
): { canvasX: number; canvasY: number } {
  return {
    canvasX: pdfX * scale,
    canvasY: (pageHeightPdf - pdfY) * scale,
  };
}

function round(value: number): number {
  return Math.round(value * 10) / 10;
}
